import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMDisplayErrorTypes } from '#src/types/DMDisplayErrorTypes'

export default class DMDisplayError extends BaseError<DMDisplayErrorTypes> {
  constructor(
    public message: string,
    public code: DMDisplayErrorTypes,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMDisplayError.prototype)
    this.name = this.constructor.name
  }
}
